import React from 'react';
import AdminRoles from 'src/components/AdminRoles';
import ResponsiveWrapper from "src/components/ResponsiveWrapper";

const ProxyRoles = () => {
    return (
        <ResponsiveWrapper>
            <AdminRoles />
        </ResponsiveWrapper>
    );
};
export default ProxyRoles;
